<template>
  <article class="membership-card" :class="'membership-card--' + membership.group">
    <header v-if="membership.group !== 'current'" class="membership-card__heading">
      <span class="membership-card__eyebrow">{{ membership.group === 'past' ? 'Vergangenes Abo' : 'Nächstes Abo' }}</span>
    </header>
    <h3>{{ membership.name }}</h3>
    <p v-if="knownStudio" class="membership-card__studio"><v-icon size="15" aria-hidden="true">mdi-map-marker-outline</v-icon>{{ membership.contractStudio }}</p>
    <div class="membership-card__term">
      <v-icon size="19" aria-hidden="true">mdi-calendar-range</v-icon>
      <div><span>Laufzeit</span><strong>{{ range(membership) }}</strong></div>
    </div>
    <slot name="actions" />
    <section v-if="currentPackages.length || upgrades.length" class="membership-card__packages" aria-label="Pakete">
      <div class="membership-card__section-title"><h4>Pakete</h4><span>{{ currentPackages.length }} dabei</span></div>
      <div class="membership-card__package-grid">
        <CustomerHubPackageCard v-for="(pack, index) in currentPackages" :key="pack.id + '-' + index" :pack="pack" />
        <CustomerHubUpgradeTile v-for="pack in upgrades" :key="pack.key" :pack="pack" @select="$emit('upgrade', $event)" />
      </div>
    </section>
    <p v-else-if="membership.group === 'current'" class="membership-card__empty">Aktuell sind keine Zusatzpakete hinterlegt.</p>
    <section v-if="futurePackages.length" class="membership-card__packages" aria-label="Kommende Zusatzpakete">
      <div class="membership-card__section-title"><h4>Demnächst dabei</h4></div>
      <div class="membership-card__package-grid">
        <CustomerHubPackageCard v-for="(pack, index) in futurePackages" :key="pack.id + '-' + index" :pack="pack" />
      </div>
    </section>

  </article>
</template>

<script>
import CustomerHubPackageCard from "./CustomerHubPackageCard.vue"
import CustomerHubUpgradeTile from "./CustomerHubUpgradeTile.vue"
export default {
  name: "CustomerHubMembershipCard",
  components: { CustomerHubPackageCard, CustomerHubUpgradeTile },
  props: { upgrades: { type: Array, default: () => [] }, membership: { type: Object, required: true }, today: { type: String, required: true } },
  computed: {
    currentPackages() { return this.membership.packages.filter(pack => pack.group === "current") },
    futurePackages() { return this.membership.packages.filter(pack => pack.group === "future") },
    knownStudio() { return this.membership.contractStudio && this.membership.contractStudio !== "Vertragsstudio nicht angegeben" },
  },
  methods: {
    date(value) { return value ? this.$moment(value, "YYYY-MM-DD").format("DD.MM.YYYY") : "nicht angegeben" },
    range(value) { return `${this.date(value.start)} – ${this.date(value.end)}` },
  },
}
</script>

<style scoped>
.membership-card { overflow: hidden; padding: 26px; margin-bottom: 18px; border-radius: 24px; background: #242424; border: 1px solid #ffffff16; color: #f5f5f5; }
.membership-card--past { background: #222222; border-color: #ffffff12; }.membership-card--future { border-style: dashed; }
.membership-card__heading { display: flex; align-items: center; justify-content: space-between; gap: 14px; margin-bottom: 16px; }
.membership-card__eyebrow { color: #bdbdbd; font-size: 12px; font-weight: 500; }
.membership-card h3 { font-size: clamp(22px, 3.5vw, 28px); font-weight: 650; letter-spacing: -.5px; line-height: 1.25; margin: 0; max-width: 640px; overflow-wrap: anywhere; }
.membership-card__studio { display: flex; align-items: center; gap: 5px; color: #bfbfbf; margin: 9px 0 0; font-size: 12px; }.membership-card__studio .v-icon { color: inherit; }
.membership-card__term { display: flex; align-items: center; gap: 12px; margin: 22px 0 0; }.membership-card__term .v-icon { color: #b7b7b7; }.membership-card__term span { display: block; font-size: 11px; color: #b9b9b9; margin-bottom: 3px; }.membership-card__term strong { font-size: 14px; font-weight: 500; font-variant-numeric: tabular-nums; }
.membership-card__packages { margin-top: 24px; }.membership-card__section-title { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; margin-bottom: 10px; }.membership-card h4 { font-size: 13px; font-weight: 600; margin: 0; }.membership-card__section-title > span { color: #b2b2b2; font-size: 11px; }
.membership-card__package-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: start; gap: 8px; }
.membership-card__empty { font-size: 12px; color: #bbbbbb; margin: 20px 0 0; }
@media (max-width: 480px) { .membership-card { padding: 20px 16px; border-radius: 20px; }.membership-card__package-grid { gap: 7px; } }
@media (max-width: 350px) { .membership-card__package-grid { grid-template-columns: minmax(0, 1fr); } }
</style>
